
import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from "@angular/forms";
@Directive({
    selector: '[upperCase]'
})
export class UppercaseDirective{

    constructor(
        private control : NgControl,
        private el: ElementRef
    ){}
  
    @HostListener('keyup') onKeyUp() {
      this.el.nativeElement.value = this.el.nativeElement.value.toUpperCase();
      this.control.control.setValue(this.el.nativeElement.value)
      console.log(this.el.nativeElement.value)
      
     
  
    }
}




// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/UppercaseDirective.ts